import { render, staticRenderFns } from "./RenameFolderModal.vue?vue&type=template&id=65ff4acf&scoped=true&lang=pug"
import script from "./RenameFolderModal.vue?vue&type=script&lang=js"
export * from "./RenameFolderModal.vue?vue&type=script&lang=js"
import style0 from "./RenameFolderModal.vue?vue&type=style&index=0&id=65ff4acf&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff4acf",
  null
  
)

export default component.exports